import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SiteLayout from '../../layouts/SiteLayout';
import Header from '../../components/Header/Header';
import Box from '../../components/Common/Box';
import { useSwingTrader } from './useSwingTrader';
import { useScreenType } from '../../hooks/useScreenType';

// Sub-components
import DesktopSwing from './DesktopSwing';
import MobileSwing from './MobileSwing';

const SwingTraderScreen: React.FC = () => {
    const { data, loading, error, refetch } = useSwingTrader();
    const navigate = useNavigate();
    const { isMobile } = useScreenType();
    const [activeTab, setActiveTab] = useState<'opportunities' | 'sell' | 'universe' | 'info'>('opportunities');
    const [strategy, setStrategy] = useState<'swing' | 'trend'>('swing');

    if (loading) {
        return (
            <SiteLayout>
                <Header title="Swing Trader" />
                <Box>
                    <div style={{ padding: 40, textAlign: 'center' }}>
                        <div className="loading-spinner" />
                        <p>Analyse des opportunités en cours...</p>
                    </div>
                </Box>
            </SiteLayout>
        );
    }

    if (error) {
        return (
            <SiteLayout>
                <Header title="Swing Trader" />
                <Box>
                    <div style={{ padding: 40, textAlign: 'center', color: '#dc2626' }}>
                        <p>Erreur: {error}</p>
                        <button 
                            onClick={refetch} 
                            style={{ 
                                marginTop: 16, 
                                padding: '10px 20px', 
                                backgroundColor: '#2563eb', 
                                color: 'white', 
                                border: 'none', 
                                borderRadius: 6, 
                                cursor: 'pointer' 
                            }}
                        >
                            Réessayer
                        </button>
                    </div>
                </Box>
            </SiteLayout>
        );
    }

    const opportunities = data?.opportunities || [];
    const sellSignals = data?.sell_signals || [];
    const eligibleUniverse = data?.eligible_universe || [];
    const sentiment = data?.market_sentiment || 'NEUTRAL';

    const sentimentColors: Record<string, { bg: string; color: string }> = {
        BULLISH: { bg: '#dcfce7', color: '#16a34a' },
        BEARISH: { bg: '#fee2e2', color: '#dc2626' },
        NEUTRAL: { bg: '#f1f5f9', color: '#475569' },
    };

    const childProps = {
        data,
        activeTab,
        setActiveTab,
        strategy,
        setStrategy,
        opportunities,
        sellSignals,
        eligibleUniverse,
        sentiment,
        sentimentColors,
        navigate: (path: string) => navigate(path)
    };

    return (
        <SiteLayout>
            <Header title="Swing Trader" />
            {isMobile ? (
                <MobileSwing {...childProps} />
            ) : (
                <DesktopSwing {...childProps} />
            )}
        </SiteLayout>
    );
};

export default SwingTraderScreen;
